import {CheatPlugin} from '../../CheatModuleInterfaces';
import {CheatSoundTool} from './CheatSoundTool';
import {CheatSoundToolView} from './CheatSoundToolView';

const soundTool: CheatPlugin = {
    name: 'Sound tool',
    init: () => [
        CheatSoundTool,
        CheatSoundToolView
    ]
};

export default soundTool;
